export var returnDropdownOptions = function (data) {
    if (data && data.length > 0) {
        return data.map(function (record) {
            return {
                value: record.id,
                display: record.name,
                parentId: record.parentId
            };
        });
    }
    else {
        return [];
    }
};
var EdelAbortSignals = /** @class */ (function () {
    function EdelAbortSignals(abortControllers) {
        var _this = this;
        this.abortControllers = abortControllers;
        this.abortSignal = function (signalKey) {
            if (_this.abortControllers[signalKey])
                _this.abortControllers[signalKey].abort();
            _this.abortControllers[signalKey] = new AbortController();
            return _this.abortControllers[signalKey].signal;
        };
    }
    return EdelAbortSignals;
}());
export { EdelAbortSignals };
